export default {
  myInfos(state) {
    return state.myInfos;
  },
};
